import React from 'react';
import { Box, Button, Modal, Typography } from '@mui/material';
import { style } from './styles';

type PropTypes = {
  errorMessage: string;
  openErrorMessageModal: boolean;
  setOpenErrorMessageModal: (open: boolean) => void;
};

export const ErrorMessageModal = ({
  errorMessage,
  openErrorMessageModal,
  setOpenErrorMessageModal,
}: PropTypes) => {
  return (
    <Modal
      open={openErrorMessageModal}
      onClose={() => setOpenErrorMessageModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h5" component="h2">
          Something went wrong.
        </Typography>
        <Typography id="modal-modal-title" mt={2}>
          {errorMessage}
        </Typography>
        <Box mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenErrorMessageModal(false)}
            sx={{ mt: 2 }}
          >
            Ok
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
